/**
 * Het afzenderveld van mail die de app namens een organisatie verstuurt.
 *
 * Het ADRES is altijd het platformadres. De SMTP-server achter de
 * firestore-send-email-extensie weigert elke andere afzender met
 * `553 5.7.1 Sender address rejected: not owned by user info@deccos.nl`, en
 * die weigering is stil: het Email-document blijft staan met delivery.state
 * ERROR en niemand in de app ziet dat (docs/inbox.md Bug #29).
 *
 * De WEERGAVENAAM mag wél van de organisatie zijn. Zo ziet een bewoner
 * "Duurzame Vecht via Deccos" in zijn postvak in plaats van een kaal
 * info@deccos.nl, en het antwoordadres (replyTo) blijft dat van de organisatie.
 *
 * De naam gaat tussen dubbele aanhalingstekens (RFC 5322 quoted-string), zodat
 * een komma of punthaak in de organisatienaam niet als tweede adres wordt
 * gelezen. Aanhalingstekens en backslashes in de naam worden ontsnapt,
 * regelovergangen eruit gehaald (header injection).
 *
 * Spiegel van `PLATFORM_SENDER` in functions/tasks/buildReminderEmail.js.
 */

const PLATFORM_SENDER = 'info@deccos.nl'

/**
 * @param {string | null | undefined} organisationName - Naam van de organisatie
 *   zoals hij in de instellingen staat; leeg → kaal platformadres
 * @returns {string} Afzenderveld in de vorm `"Naam via Deccos" <info@deccos.nl>`
 */
const buildPlatformSender = (organisationName) => {
    const name = (organisationName || '')
        .replace(/[\r\n]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    if (!name) return PLATFORM_SENDER

    const escaped = name.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
    return `"${escaped} via Deccos" <${PLATFORM_SENDER}>`
}

export default buildPlatformSender
export { PLATFORM_SENDER }
